import { PaginatedData } from '../types'

export interface IQuizColor {
  bgEnd: string
  bgStart: string
  text: string
}

export interface IQuizQuestion {
  colors: IQuizColor
  createdAt: string
  deletedAt: string | null
  id: number
  imageUrl: string
  quizId: string
  title: string
  updatedAt: string
}

export interface IQuiz {
  colors: IQuizColor
  completed: boolean
  createdAt: string
  deletedAt: string | null
  id: number
  imageUrl: string
  public: boolean
  questions: IQuizQuestion[]
  title: string
  updatedAt: string
}

export type IQuizzesResponse = PaginatedData<IQuiz>

export enum ActionAnswer {
  up = 'love',
  down = 'dislike',
  left = 'dunno',
  right = 'like',
  skip = 'skip',
}
